@if (!isProcessing) {
    <button 
        (click)="onAddPaymentMethodClicked()" 
        class="flex flex-row items-center gap-1 p-1 bg-slate-100 rounded shadow-sm fill-none stroke-slate-900 hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
        <svg-icon [svgIcon]="addSvgIcon" [small]="true"></svg-icon>
        <div>Add Payment Method</div>
    </button>
} @else {
    <busy-spin [small]="true" class="pr-2"></busy-spin>
}